import type { TFunction } from "i18next";
import U2000DeleteRecordDialog from "../../../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import type { U2102RoleActionHandler } from "./U2102RoleActionHandlers";
import type { U2102LogicalUnit } from "../../../../U2102Service";

// Typage des props du composant
interface U2102RoleActionDeleteDlgProps {
  u2102RoleActionHandler: U2102RoleActionHandler;
  t: TFunction;
  NS: string;
}

function U2102RoleActionDeleteDlg({ u2102RoleActionHandler, t, NS }: U2102RoleActionDeleteDlgProps) {
  // Plus besoin de helpers custom, U2000CheckBoxArray gère tout

  if (!u2102RoleActionHandler.isDeleteDialogOpen) return null;

  return (
    <U2000DeleteRecordDialog isOpen={u2102RoleActionHandler.isDeleteDialogOpen} onClose={u2102RoleActionHandler.onDlgDeleteClose} title={t("lblLogicalUnitAction", { ns: NS })}>
      <p className="mb-4">
        {t("msgDeleteLogicalUnitAction", {
          count: u2102RoleActionHandler.gridStateHandlers.getSelectedRows().length,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {u2102RoleActionHandler.gridStateHandlers.getSelectedRows().map((row, index, array) => {
          const lu = row as unknown as U2102LogicalUnit;
          return (
            <span key={lu.logicalUnitCode} className="inline-block text-gray-800">
              {`${lu.logicalUnitCode} - ${lu.logicalUnitDescription}`}
              {index < array.length - 1 && ", "}
            </span>
          );
        })}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U2102RoleActionDeleteDlg;
